
// native
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// service
import { ToastService } from './toast.service';
import { GlobalsService } from './globals.service';

// model
import { LegacyConvertPayload, IDocumentStyle } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class LegacyService {

  legacyLoading$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private globalsService: GlobalsService,
    private toastService: ToastService
  ) { }

  async convertLegacy(style: IDocumentStyle, locale: string, language: string, showNoCitationsToast = false): Promise<void> {
    // to prevent flicker for very fast convert legacy (no convert needed)
    const timeout = setTimeout(() => this.legacyLoading$.next(true), 300);

    return this.globalsService.appConfig.convertLegacy(style, locale, language).then((result: LegacyConvertPayload) => {
      clearTimeout(timeout);

      this.legacyLoading$.next(false);

      if (!result.citationsFound) {
        showNoCitationsToast && this.toastService.openToast({
          text: 'There are no citations in the document that need updating.',
          type: 'success'
        });
        return;
      }

      if (result.cannotConvertInWordOnline === true) {
        this.toastService.openToast({
          text: `Due to an update, Word Online documents must be updated by SmartCite using the desktop version of Word. 
            To do so, please open this document in a desktop version of Word and open the SmartCite Add-in sidebar. 
            The document will automatically be updated, after which you may continue to edit the document in Word Online as usual. 
            If you don’t have access to word desktop or if you have any other questions or concerns please reach out to support@papersapp.com.`,
          type: 'error',
          isFullScreen: true,
          closeDisabled: true,
          autoClose: false
        });
        return;
      }

      if (result.canceled === true) {
        this.toastService.openToast({
          text: `Missing inline citations have been marked in red and document is still not updated. 
            If you wish to update the document to the new version of Smartcite, you can do it from the Options tab.`,
          type: 'error',
          autoClose: false
        });
        return;
      }

      if (result.allConverted === true) {
        this.toastService.openToast({
          text: 'All valid citations have been updated.',
          type: 'success'
        });
        return;
      }

      if (result.allConverted === false) {
        this.toastService.openToast({
          text: 'Some inline citations have not been updated due to errors and have been marked in red. Please fix these citations manually by reinserting.',
          type: 'error',
          autoClose: false
        });
        return;
      }
    })
      .catch(() => {
        this.legacyLoading$.next(false);

        this.toastService.openToast({
          text: 'There was an error while updating existing document citations.',
          type: 'error',
          autoClose: false
        });
      });
  }
}